import { HomeProcessingRule } from '../interfaces';

export const homeAuthenticationRule: HomeProcessingRule = context => ({
	...context,
	isLoggedIn: Boolean(context.auth),
});
